import { render, staticRenderFns } from "./Daoying.vue?vue&type=template&id=070e6ab1&scoped=true&"
import script from "./Daoying.vue?vue&type=script&lang=js&"
export * from "./Daoying.vue?vue&type=script&lang=js&"
import style0 from "./Daoying.vue?vue&type=style&index=0&id=070e6ab1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070e6ab1",
  null
  
)

export default component.exports